import Joyride from 'react-joyride';

export const LiveGuide = ({ steps, ...props }) => {
    return <Joyride steps={steps} {...props} />
};

export default LiveGuide

